import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import {SEO} from "@/components/SEO.tsx";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    /*console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );*/
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SEO
          title="404"
          description="Page not found. Let's get you back on track"
          type="website"
          name="blankpoll"
          imageUrl="/blankpoll-banner.jpg"
      />
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
